import gql from 'graphql-tag'
import { default as fragments } from './fragments'


export const MUTATION_REQUESTRUN = gql`
  mutation ($input: RequestRunMutationInput!) {
    requestrunMutate(input: $input) {
      requestrun {
        ...RequestRun
      }
    }
  }
  ${fragments.requestRun}
`

export const MUTATION_FILERELATION = gql`
  mutation ($input: FileRelationMutationInput!) {
    filerelationMutate(input: $input) {
      filerelation {
        ...FileRelation
      }
    }
  }
  ${fragments.fileRelation}
`

export const MUTATION_FILERELATION_DELETE = gql`
  mutation ($input: FileRelationDeleteInput!) {
    filerelationDelete(input: $input) {
      outcome
    }
  }
`

export const MUTATION_IDENTITYBANKACCOUNT = gql`
  mutation ($input: IdentityBankAccountMutationInput!) {
    identitybankaccountMutate(input: $input) {
      ...IdentityBankAccount
    }
  }
  ${fragments.identityBankAccount}
`

export const MUTATION_WORKFLOWRUN = gql`
  mutation ($input: WorkflowRunMutationInput!) {
    workflowrunMutate(input: $input) {
      ...WorkflowRun
    }
  }
  ${fragments.workflowRun}
`

export const MUTATION_CLIENTINVESTMENT = gql`
  mutation ($input: ClientInvestmentMutationInput!) {
    clientinvestmentMutate(input: $input) {
      clientinvestment {
        ...ClientInvestment
      }
    }
  }
  ${fragments.clientInvestment}
`

export const MUTATION_CLIENT_CLIENTINVESTMENTS = gql`
  mutation ($input: ClientMutationInput!) {
    clientMutate(input: $input) {
      client {
        id
        clientinvestments {
          edges {
            node {
              ...ClientInvestment
            }
          }
        }
      }
    }
  }
  ${fragments.clientInvestment}
`

export const MUTATION_WITHDRAWAL = gql`
  mutation ($input: WithdrawalMutationInput!) {
    withdrawalMutate(input: $input) {
      withdrawal {
        ...Withdrawal
      }
    }
  }
  ${fragments.withdrawal}
`

export const WITHDRAWAL_BANKACCOUNT_UPDATE = gql`
  mutation ($input: BankaccountUpdateInput!) {
    bankaccountUpdate(input: $input) {
      withdrawal {
        ...Withdrawal
      }
    }
  }
  ${fragments.withdrawal}
`

export const MUTATION_WITHDRAWAL_BATCH = gql`
  mutation ($input: WithdrawalBatchMutationInput!) {
    withdrawalbatchMutate(input: $input) {
      withdrawalbatch {
        ...WithdrawalBatch
      }
    }
  }
  ${fragments.withdrawalbatch}
`

export const MUTATION_WITHDRAWAL_BATCH_DELETE = gql`
  mutation ($input: WithdrawalBatchDeleteInput!) {
    withdrawalbatchDelete(input: $input) {
      outcome
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations.js